import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Search } from "@mui/icons-material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useForm, Controller } from "react-hook-form";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import DelIcon from "@mui/icons-material/Delete";
import { ToastContainer, toast } from "react-toastify";
import { Accordion, AccordionActions, AccordionSummary, AccordionDetails, Paper } from "@mui/material";
import {
  Stack,
  Autocomplete,
  TextField,
  Button,
  Typography,
  Box,
  Tooltip,
  CircularProgress,
  Dialog,
  DialogTitle,
  Alert,
  Card,
  OutlinedInput,
  IconButton,
  InputAdornment,
  Checkbox,
} from "@mui/material";
import {
  deleteCustomerAddress,
  readCustomerById,
  readMachinesByCustomerId,
  readMachinesCountByCustomerId,
} from "../../../features/customers/actions";
import {
  addContactToLead,
  updateContact,
  updateLead,
  readAllCustomersByState,
  deleteContactById,
  deleteLocationById,
  addMachineToCustomers,
  addLocationsToCustomers,
  deleteMachineFromCustomer,
} from "../../../features/customers/actions";
import { getAppUsers } from "../../../features/users/actions";
import { readAsyncStorageValues } from "../../../features/common/actions";
import { QrCode as QRCodeIcon, Delete as DeleteIcon } from "@mui/icons-material";
import jsPDF from "jspdf";
import { LinearProgress } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const CustomerContact = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { indianStateDropdownOptions, machineModels, machineManufacturers, asyncStorageValues } = useSelector((state) => state.common);
  const { machinesByCustomerId, customerDataById, loading, machinesCountByCustomerId } = useSelector((state) => state.customers);
  const [editCustomer, setEditCustomer] = useState(null);
  const [resetPassword, setResetPassword] = useState(false);
  const {
    register: addEditMachineFormRegister,
    handleSubmit: addEditMachineHandleSubmit,
    reset: resetMachineInput,
    setValue,
    watch,
  } = useForm();
  const { appUsersList } = useSelector((state) => state.users);

  const {
    control: addressControl,
    register: addEditLocationFormRegister,
    handleSubmit: addEditLocationHandleSubmit,
    reset: resetLocationInput,
  } = useForm();
  const { control, register: editFormRegister, handleSubmit: editHandleSubmit, reset: resetCustomer } = useForm();
  const { register: addEditContactFormRegister, handleSubmit: addEditHandleSubmit, reset, setValue: addEditSetValue } = useForm();
  const [addContact, setAddContact] = useState(null);
  const [machineLocation, setMachineLocation] = useState(null);
  const [selectedIndianState, setSelectedIndianState] = useState({ label: "Maharashtra (MH)", value: "MH" });
  const [selectedContact, setSelectedContact] = useState(null);
  const [contactInfo, setContactInfo] = useState(null);
  const [selectedMachine, setSelectedMachine] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [selectedModel, setSelectedModel] = useState(null);
  const [warrantyExpiryDate, setwarrantyExpiryDate] = useState(null);
  const [amcExpiryDate, setamcExpiryDate] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteMachineModel, setDeleteMachineModel] = useState(null);
  const [deleteCustomerContact, setDeleteCustomerContact] = useState(null);
  const [deleteAddress, setDeleteAddress] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchContactTerm, setSearchContactTerm] = useState("");
  const [searchLocationTerm, setSearchLocationTerm] = useState("");
  const [downloadProgress, setDownloadProgress] = useState(null);
  const [hideProgress, setHideProgress] = useState(true);
  const [editContactModal, setEditContactModal] = useState(false);
  const [editMachineModal, setAddEditMachineModal] = useState(false);
  const [addEditLocationModal, setAddEditLocationModal] = useState(false);
  const [customerAddresses, setCustomerAddresses] = useState([]);
  const [machineLocations, setMachineLocations] = useState([]);
  const [selectedManufacturer, setSelectedManufacturer] = useState(null);
  const [serialNumberLength, setSerialNumberLength] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [allowTicketCreation, setAllowTicketCreation] = useState(null);
  const [emailServiceReport, setEmailServiceReport] = useState(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [userList, setUserList] = useState([]);
  const [selectedMachineItems, setSelectedMachineItems] = useState([]);
  const [contactName, setContactName] = useState(selectedContact?.name || "");
  const [userName, setUserName] = useState(selectedContact?.info?.username || "");
  const [userPassword, setUserPassword] = useState("");
  const [userConfirmPassword, setUserConfirmPassword] = useState("");
  const [customerUsers, setCustomerUsers] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    dispatch(getAppUsers());
  }, [dispatch]);

  useEffect(() => {
    if (appUsersList?.data) {
      setUserList(appUsersList.data);
      const filtered = appUsersList.data.filter((user) => user.userRole === "ROLE_CUSTOMER" && String(user.customerId) === id);
      setCustomerUsers(filtered);
    }
  }, [appUsersList, id]);

  useEffect(() => {
    if (selectedMachine?.serialNumber) {
      setSerialNumberLength(selectedMachine.serialNumber.length);
    } else {
      setSerialNumberLength(0);
    }
  }, [selectedMachine?.serialNumber]);

  useEffect(() => {
    if (selectedContact) {
      setContactName(selectedContact.name || "");
    }
  }, [selectedContact]);

  // useEffect(() => {
  //   if (selectedContact?.info) {
  //     try {
  //       const parsedInfo = JSON.parse(selectedContact.info);
  //       setContactInfo(parsedInfo);
  //     } catch (error) {
  //       console.error("Error parsing contact info: ", error);
  //       setContactInfo(null);
  //     }
  //   } else {
  //     setContactInfo(null);
  //   }
  // }, [selectedContact]);

  useEffect(() => {
    setAllowTicketCreation((prev) => {
      return contactInfo?.canCreateTickets || false;
    });
  }, [contactInfo]);

  // useEffect(() => {
  //   setShowPasswordField(allowTicketCreation && (!selectedContact?.id || !selectedContact?.info?.canCreateTickets));
  // }, [allowTicketCreation, selectedContact]);

  useEffect(() => {
    dispatch(readAsyncStorageValues());
    dispatch(readMachinesByCustomerId(id));
    dispatch(readMachinesCountByCustomerId(id));
    dispatch(readCustomerById(id));
  }, [dispatch]);
  useEffect(() => {
    dispatch(readMachinesCountByCustomerId(id));
  }, [machinesByCustomerId]);

  useEffect(() => {
    reset(null);
    setValidationErrors((prevState) => ({ ...prevState, contactEmail: null, contactNumber: null }));
  }, [editContactModal]);

  useEffect(() => {
    resetMachineInput(null);
    setValidationErrors((prevState) => ({ ...prevState, manufacturingYear: null }));
  }, [editMachineModal]);

  useEffect(() => {
    resetLocationInput(null);
    // if (addEditLocationModal) {
    //   setSelectedAddress({ locations: ["Default"] });
    // }
  }, [addEditLocationModal]);

  useEffect(() => {
    if (customerDataById && customerDataById?.info) {
      const customerInfo = customerDataById?.info;
      const customerLocations = customerInfo?.addresses || [];
      //wefewf
      const formattedAddresses = customerLocations.map((item) => ({
        ...item,
        location: item.locations.join(", "),
      }));

      setCustomerAddresses([...formattedAddresses].sort((a, b) => a.address.localeCompare(b.address)));
    }
  }, [customerDataById]);

  const handleBackClick = () => {
    navigate(-1);
  };
  const inputChangeHandler = (event) => {
    const mobileNumberRegex = /^[0-9+().\-\s]*$/;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const yearRegex = /^[1-9]\d{3}$/;
    const passwordRegex = /^.{6,}$/;
    let id = event.target.id;
    let value = event.target.value;
    if (id === "name") {
      if (!value) {
        setValidationErrors((prevState) => ({ ...prevState, name: "Name is required" }));
      } else {
        setValidationErrors((prevState) => ({ ...prevState, name: null }));
      }
    } else if (id === "number") {
      if (!mobileNumberRegex.test(value)) {
        setValidationErrors((prevState) => ({ ...prevState, number: "Please enter a valid Phone Number" }));
      } else {
        setValidationErrors((prevState) => ({ ...prevState, number: null }));
      }
    } else if (id === "email") {
      if (!emailRegex.test(value)) {
        setValidationErrors((prevState) => ({ ...prevState, email: "Please enter a valid email" }));
      } else {
        setValidationErrors((prevState) => ({ ...prevState, email: null }));
      }
    } else if (id === "contactNumber") {
      if (!mobileNumberRegex.test(value)) {
        setValidationErrors((prevState) => ({ ...prevState, contactNumber: "Please enter a valid Phone Number" }));
      } else {
        setValidationErrors((prevState) => ({ ...prevState, contactNumber: null }));
      }
    } else if (id === "contactEmail") {
      if (!emailRegex.test(value)) {
        setValidationErrors((prevState) => ({ ...prevState, contactEmail: "Please enter a valid email" }));
      } else {
        setValidationErrors((prevState) => ({ ...prevState, contactEmail: null }));
      }
    } else if (id === "manufacturingYear") {
      if (!yearRegex.test(value)) {
        setValidationErrors((prevState) => ({ ...prevState, manufacturingYear: "Please enter a valid year" }));
      } else {
        setValidationErrors((prevState) => ({ ...prevState, manufacturingYear: null }));
      }
    } else if (id === "password" && allowTicketCreation) {
      setPassword(value);
      setValidationErrors((prevState) => ({
        ...prevState,
        password: passwordRegex.test(value) ? null : "Password must be at least 6 characters long",
        confirmPassword: confirmPassword && value !== confirmPassword ? "Passwords do not match" : null, // Revalidate confirmPassword
      }));
    } else if (id === "confirmPassword" && allowTicketCreation) {
      setConfirmPassword(value);
      setValidationErrors((prevState) => ({
        ...prevState,
        confirmPassword: value === password ? null : "Passwords do not match",
      }));
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleCheckboxChange = (event) => {
    setAllowTicketCreation(event.target.checked);
  };

  useEffect(() => {
    setCustomerName(customerDataById?.name?.trim() || "");
  }, [customerDataById]);

  const generateMaintenanceCode = () => {
    if (customerDataById?.name) {
      const machineCount = machinesCountByCustomerId?.data?.totalMachines || 0;
      const autoGeneratedCode = customerDataById.name.substring(0, 20).replace(/\s/g, "_") + "_" + (machineCount + 101);

      setValue("maintenanceCode", selectedMachine?.maintenanceCode || autoGeneratedCode, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
    return "";
  };
  const [customerName, setCustomerName] = useState(customerDataById?.name?.trim() || "");

  useEffect(() => {
    setCustomerName(customerDataById?.name?.trim() || "");
  }, [customerDataById]);

  const editCustomerForm = () => (
    <Box component="form" onSubmit={editHandleSubmit(submitEditForm)} noValidate id="editCustomerForm">
      <Stack rowGap={2}>
        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            margin="normal"
            required
            fullWidth
            defaultValue={customerName.trim() || ""}
            id="customerName"
            label="Customer Name"
            name="customerName"
            autoFocus
            {...editFormRegister("customerName")}
            error={Boolean(validationErrors.name)}
            helperText={validationErrors.name ? validationErrors.name : ""}
            onChange={inputChangeHandler}
          />

          <Controller
            control={control}
            name="state"
            defaultValue={indianStateDropdownOptions.find((item) => item.label == customerDataById?.state) || ""}
            rules={{
              required: "required field",
            }}
            render={({ field: { onChange } }) => (
              <Autocomplete
                disablePortal
                required
                fullWidth
                style={{ marginTop: 8 }}
                options={indianStateDropdownOptions}
                defaultValue={indianStateDropdownOptions.find((item) => item.label == customerDataById?.state) || ""}
                getOptionLabel={(option) => option.label}
                isOptionEqualToValue={(option, value) => option.label == value.label}
                onChange={(event, item) => onChange(item)}
                renderInput={(params) => <TextField {...params} label="State" />}
              />
            )}
          />
        </Stack>

        <Stack direction="row" spacing={2} alignItems="center">
          <TextField
            margin="normal"
            defaultValue={customerDataById?.telephoneNumber || ""}
            fullWidth
            id="number"
            label="Phone Number"
            name="number"
            {...editFormRegister("number")}
            error={Boolean(validationErrors.number)}
            helperText={validationErrors.number ? validationErrors.number : ""}
            onChange={inputChangeHandler}
            style={{ marginTop: 6 }}
          />
          <TextField
            margin="normal"
            defaultValue={customerDataById?.emailAddress || ""}
            fullWidth
            id="email"
            label="Email"
            name="email"
            {...editFormRegister("email")}
            error={Boolean(validationErrors.email)}
            helperText={validationErrors.email ? validationErrors.email : ""}
            onChange={inputChangeHandler}
          />
          <TextField
            margin="normal"
            fullWidth
            defaultValue={customerDataById?.gstNumber || ""}
            id="gstNumber"
            label="Gst Number"
            name="gstNumber"
            {...editFormRegister("gstNumber")}
          />
        </Stack>
        <Stack style={{ flexDirection: "row", justifyContent: "center" }}>
          <Button
            type="button"
            variant="contained"
            sx={{ height: "self", marginRight: 5, width: 100 }}
            onClick={() => {
              setEditCustomer(null);
            }}
          >
            Close
          </Button>
          <Button type="submit" variant="contained" sx={{ height: "self", width: 100 }}>
            Save
          </Button>
        </Stack>
      </Stack>
    </Box>
  );

  //MACHINE

  const submitAddEditMachineForm = async (data) => {
    if (selectedModel?.id && data.maintenanceCode.length > 0 && data.serialNumber.length > 0 && !validationErrors.manufacturingYear) {
      let collection = {};
      if (selectedMachine) collection.machineId = selectedMachine.id;
      collection.customerId = customerDataById.id;
      collection.modelId = selectedModel.id;
      collection.serialNumber = data.serialNumber.toUpperCase();
      collection.maintenanceCode = data.maintenanceCode;
      collection.manufacturingYear = data.manufacturingYear;
      // if (machineLocation) collection.location = machineLocation;
      collection.machineModel = selectedModel.id;
      if (amcExpiryDate) collection.amcExpiryDate = amcExpiryDate;
      else if (warrantyExpiryDate) collection.warrantyExpiryDate = warrantyExpiryDate;

      let info = {};
      if (selectedMachine?.info) {
        if (typeof selectedMachine.info === "string") {
          try {
            info = JSON.parse(selectedMachine.info);
          } catch (error) {
            console.error("Error parsing info JSON:", error);
            info = {};
          }
        } else {
          info = { ...selectedMachine.info };
        }
      }

      if (data.notes) info.notes = data.notes;
      if (machineLocation && typeof machineLocation === "object" && machineLocation.location && machineLocation.id) {
        info.location = { ...machineLocation };
      }

      collection.info = JSON.stringify(info);
      if (selectedMachine) {
        dispatch(addMachineToCustomers(collection)).then((res) => {
          dispatch(readMachinesByCustomerId(id)).then((res) => {});
          resetMachineInput(null);
          toast.success(` Machine Updated `, { autoClose: 1000 });
        });
      } else {
        dispatch(addMachineToCustomers(collection)).then((res) => {
          dispatch(readMachinesByCustomerId(id)).then((res) => {});
          resetMachineInput(null);
          toast.success(` Machine Added `, { autoClose: 1000 });
        });
      }
      setSelectedMachine(null);
      setSelectedModel(null);
      handleCloseEditMachineModal();
    } else {
      toast.warn("Please fill all the required fields(*)");
    }
  };
  const deleteFunction = async () => {
    if (deleteMachineModel) {
      await dispatch(deleteMachineFromCustomer(deleteMachineModel)).then((res) => {
        dispatch(readMachinesByCustomerId(id)).then((res) => {});
        dispatch(readCustomerById(id)).then((res) => {});
        resetMachineInput(null);
        toast.success(`Machine is deleted`, { autoClose: 1000 });
      });
    } else if (deleteCustomerContact) {
      await dispatch(deleteContactById(deleteCustomerContact));
      reset(null);
      dispatch(readCustomerById(id));
      toast.success(`Contact is deleted`, { autoClose: 1000 });
      setDeleteCustomerContact(null);
    } else if (deleteAddress) {
      dispatch(deleteCustomerAddress({ customerId: id || customerDataById?.id, addressId: deleteAddress?.id })).then(() => {
        dispatch(readCustomerById(id));
        resetLocationInput(null);
        toast.success(` Address deleted.`, { autoClose: 1000 });
      });
      setSelectedAddress(null);
      setDeleteAddress(null);
      handleCloseEditLocationModal();
    }
    setDeleteModal(false);
  };

  const uniqueManufacturers = [...new Set(machineModels.map((item) => item.manufacturer))]
    .map((manufacturer) => ({ manufacturer }))
    .sort((a, b) => a.manufacturer.localeCompare(b.manufacturer));

  const addEditMachineForm = () => (
    <Box
      component="form"
      onSubmit={addEditMachineHandleSubmit(submitAddEditMachineForm)}
      noValidate
      id="addMachineForm"
      sx={{ minWidth: 500, margin: "0 auto" }} // Adjust the width as needed
    >
      <Stack rowGap={2}>
        <Autocomplete
          required
          id="manufacturer"
          name="manufacturer"
          options={uniqueManufacturers}
          getOptionLabel={(option) => option.manufacturer || ""}
          isOptionEqualToValue={(option, value) => option.manufacturer === value.manufacturer}
          defaultValue={machineModels.find((item) => item.manufacturer == selectedMachine?.manufacturer) || null}
          onChange={(event, item) => {
            setSelectedManufacturer(item?.manufacturer || "");
            const firstModel = machineModels.find((model) => model.manufacturer === item?.manufacturer) || null;
            setSelectedModel(firstModel);
          }}
          renderInput={(params) => <TextField {...params} label="Manufacturer*" />}
        />
        <Autocomplete
          required
          fullWidth
          name="machineModel"
          id="machine model"
          options={machineModels.filter((model) => model.manufacturer === selectedManufacturer)}
          getOptionLabel={(option) => option.model}
          isOptionEqualToValue={(option, value) => option.model === value.model}
          value={
            selectedModel ||
            machineModels.find((item) => item.model === selectedMachine?.model && item.manufacturer === selectedMachine?.manufacturer) ||
            null
          }
          onChange={(event, item) => setSelectedModel(item)}
          renderInput={(params) => <TextField {...params} label="Machine model*" />}
        />
        <Box width="100%">
          <TextField
            margin="normal"
            fullWidth
            defaultValue={selectedMachine?.serialNumber || ""}
            id="serialNumber"
            label="Serial number*"
            name="serialNumber"
            InputProps={{
              inputProps: { maxLength: 32 },
            }}
            {...addEditMachineFormRegister("serialNumber")}
            onChange={(e) => setSerialNumberLength(e.target.value.length)}
          />
          <Typography variant="caption" color="textSecondary" sx={{ display: "block", textAlign: "right", mt: 0.5 }}>
            {Math.max(0, 32 - serialNumberLength)} characters remaining
          </Typography>
        </Box>
        <TextField
          margin="normal"
          //required
          fullWidth
          defaultValue={selectedMachine?.info?.notes || ""}
          id="notes"
          label="Notes"
          name="notes"
          InputProps={{
            inputProps: { maxLength: 250 },
          }}
          // autoFocus
          {...addEditMachineFormRegister("notes")}
        />

        <TextField
          margin="normal"
          fullWidth
          id="maintenanceCode"
          label="Machine Code"
          name="maintenanceCode"
          InputProps={{
            inputProps: { maxLength: 250 },
            readOnly: true, // ✅ Use readOnly instead of disabled
          }}
          value={selectedMachine?.maintenanceCode || watch("maintenanceCode")} // ✅ Ensure the value updates dynamically
          {...addEditMachineFormRegister("maintenanceCode")}
        />

        <Autocomplete
          disablePortal
          required
          fullWidth
          name="customerAddresses"
          id="customerAddresses"
          options={customerAddresses}
          getOptionLabel={(option) => option.name}
          isOptionEqualToValue={(option, value) => option.name == value.name}
          defaultValue={customerAddresses.find((item) => item.id == selectedMachine?.info?.address?.id) || null}
          onChange={(e, newValue) => {
            setSelectedMachine({
              ...selectedMachine,
              info: selectedMachine?.info ? { ...selectedMachine?.info, address: newValue } : { address: newValue },
            });
            setMachineLocations(newValue?.locations || []);
          }}
          // sx={{ width: 500, height: 50 }}
          renderInput={(params) => <TextField {...params} label="Address" />}
        />
        <Autocomplete
          disabled={machineLocations.length ? false : true}
          disablePortal
          required
          fullWidth
          name="machineLocation"
          id="machineLocation"
          options={machineLocations}
          defaultValue={selectedMachine?.info?.location || null}
          onChange={(e, newValue) => {
            setSelectedMachine({
              ...selectedMachine,
              info: selectedMachine?.info ? { ...selectedMachine?.info, location: newValue } : { location: newValue },
            });
            setMachineLocation(newValue);
          }}
          // sx={{ width: 500, height: 50 }}
          renderInput={(params) => <TextField {...params} label="Location" />}
        />
        <TextField
          margin="normal"
          fullWidth
          defaultValue={selectedMachine?.manufacturingYear || ""}
          id="manufacturingYear"
          label="Manufacturing year"
          name="manufacturingYear"
          InputProps={{
            inputProps: { maxLength: 4 },
          }}
          // autoFocus
          {...addEditMachineFormRegister("manufacturingYear")}
          error={Boolean(validationErrors.manufacturingYear)}
          helperText={validationErrors.manufacturingYear ? validationErrors.manufacturingYear : ""}
          onChange={inputChangeHandler}
        />

        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            minDate={moment(new Date())}
            sx={{
              flex: 1,
              "& .Mui-error": {
                color: "black",
              },
              "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: "#C8C8C8",
                borderBlockColor: "#C8C8C8",
                color: "black",
              },
              "& .MuiInputLabel-root": {
                color: "#888888",
              },
              "& .MuiInputBase-input": {
                color: "black",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "black",
              },
            }}
            label="Amc"
            format={"DD MM YYYY"}
            value={moment(selectedMachine?.amcExpiryDate || "")}
            // autoFocus
            onChange={(newValue) => setamcExpiryDate(newValue)}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            minDate={moment(new Date())}
            sx={{
              flex: 1,
              "& .Mui-error": {
                color: "black",
              },
              "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
                borderColor: "#C8C8C8",
                borderBlockColor: "#C8C8C8",
                color: "black",
              },
              "& .MuiInputLabel-root": {
                color: "#888888",
              },
              "& .MuiInputBase-input": {
                color: "black",
              },
              "& .MuiInputBase-input::placeholder": {
                color: "black",
              },
            }}
            label="Warranty"
            format={"DD MM YYYY"}
            value={moment(selectedMachine?.warrantyExpiryDate || "")}
            // autoFocus
            onChange={(newValue) => setwarrantyExpiryDate(newValue)}
          />
        </LocalizationProvider>
        <Stack flexDirection={"row"} sx={{ justifyContent: "center", gap: 2 }}>
          <Button onClick={() => handleCloseEditMachineModal()} fullWidth variant="contained" sx={{ height: 40, mr: 4 }}>
            Close
          </Button>
          <Button type="submit" fullWidth variant="contained" sx={{ height: 40 }}>
            Submit
          </Button>
        </Stack>
      </Stack>
    </Box>
  );

  const submitEditForm = async (data) => {
    if (!validationErrors.name && !validationErrors.number && !validationErrors.email) {
      await dispatch(
        updateLead({
          state: data.state.label,
          id: customerDataById.id,
          telephoneNumber: data.number,
          emailAddress: data.email,
          name: data.customerName.toUpperCase(),
          gstNumber: data.gstNumber,
        })
      ).then(() => dispatch(readCustomerById(id)));

      toast.success(`${data.customerName} customer Updated`, { autoClose: 1000 });
      dispatch(readAllCustomersByState({ indianStateCode: selectedIndianState.value }));
      setEditCustomer(null);
    } else {
      toast.warn("Please fill all the required fields(*)");
    }
  };
  const addressTypes = asyncStorageValues?.configData?.addressType
    ? [...asyncStorageValues?.configData?.addressType].sort((a, b) => a.localeCompare(b))
    : [];

  const [inputValue, setInputValue] = useState("");

  const renderAddButton = () => {
    const isInvalid = !inputValue.trim() || inputValue === "0";

    const ifExists = selectedAddress?.locations
      ? selectedAddress?.locations.filter((locationItem) => inputValue && locationItem.toLowerCase() === inputValue.toLowerCase())
      : [];
    return (
      <Button
        variant="contained"
        onClick={() => {
          if (inputValue && ifExists.length == 0 && !isInvalid) {
            setSelectedAddress({
              ...selectedAddress,
              locations: selectedAddress?.locations ? [...selectedAddress.locations, inputValue] : [inputValue],
            });
            setInputValue(""); // Clear the input field after adding
          }
        }}
        disabled={!inputValue || ifExists.length} // Disable if input is empty or already in options
        style={{ marginLeft: 8 }} // Add some space between the TextField and the button
      >
        Add
      </Button>
    );
  };
  const handleClear = (itemToRemove) => {
    setSelectedAddress({
      ...selectedAddress,
      locations: selectedAddress?.locations.filter((item) => item !== itemToRemove),
    });
  };

  const addEditLocationForm = () => (
    <Box
      component="form"
      onSubmit={addEditLocationHandleSubmit(submitAddEditLocationForm)}
      noValidate
      id="addMachineForm"
      sx={{ minWidth: 500, margin: "0 auto" }} // Adjust the width as needed
    >
      <Stack rowGap={2}>
        <TextField
          margin="normal"
          //required
          multiline
          fullWidth
          defaultValue={selectedAddress?.name || ""}
          id="addressName"
          label="Name*"
          name="addressName"
          InputProps={{
            inputProps: { maxLength: 250, style: { maxHeight: 150 } },
          }}
          // autoFocus
          {...addEditLocationFormRegister("name")}
        />
        <TextField
          margin="normal"
          //required
          multiline
          fullWidth
          defaultValue={selectedAddress?.address || ""}
          id="address"
          label="Address*"
          name="address"
          InputProps={{
            inputProps: { maxLength: 250, style: { maxHeight: 150 } },
          }}
          // autoFocus
          {...addEditLocationFormRegister("address")}
        />
        <Controller
          control={addressControl}
          name="type"
          defaultValue={addressTypes.find((item) => item == selectedAddress?.type) || ""}
          rules={{
            required: "required field",
          }}
          render={({ field: { onChange } }) => (
            <Autocomplete
              disablePortal
              required
              fullWidth
              style={{ marginTop: 8 }}
              options={addressTypes}
              defaultValue={addressTypes.find((item) => item == selectedAddress?.type) || ""}
              onChange={(event, item) => onChange(item)}
              renderInput={(params) => <TextField {...params} label="Type*" />}
            />
          )}
        />
        <Box style={{ marginTop: 8 }}>
          {/* Displaying the options with close icons */}
          <Typography fontWeight={"bold"} mb={2}>
            Locations :{" "}
          </Typography>
          {selectedAddress?.locations ? (
            <Box display="flex" flexWrap="wrap" gap={1} style={{ marginBottom: 8 }}>
              {selectedAddress.locations.map((item) => (
                <Box key={item} display="flex" alignItems="center" bgcolor="lightgray" borderRadius={4} sx={{ px: 1 }}>
                  <span>{item}</span>
                  <IconButton onClick={() => handleClear(item)} size="small" style={{ marginLeft: 4 }}>
                    <CloseIcon fontSize="small" />
                  </IconButton>
                </Box>
              ))}
            </Box>
          ) : null}

          {/* TextField for adding new items */}
          <Box display="flex" alignItems="center" style={{ marginTop: 8 }}>
            <TextField
              margin="normal"
              fullWidth
              id="location"
              label="Add Location*"
              name="location"
              InputProps={{
                inputProps: { maxLength: 250 },
              }}
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
            />
            {renderAddButton()}
          </Box>
        </Box>
        <Stack flexDirection={"row"} sx={{ justifyContent: "center", gap: 2 }}>
          <Button onClick={() => handleCloseEditLocationModal()} fullWidth variant="contained" sx={{ height: 40, mr: 4 }}>
            Close
          </Button>
          <Button type="submit" fullWidth variant="contained" sx={{ height: 40 }}>
            Submit
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
  const submitAddEditLocationForm = async (data) => {
    if (data?.name && data?.address && data?.type) {
      let collection = {};
      if (deleteAddress) {
        collection.addresses = customerAddresses.filter((item) => item.id !== deleteAddress.id);
      } else {
        if ((selectedAddress?.locations && !selectedAddress?.locations.length) || !selectedAddress?.locations) {
          return toast.warn(` Atleast one location needed!`, { autoClose: 1000 });
        }
        if (selectedAddress && selectedAddress.id) {
          const addressesToUpdateIndex = customerAddresses.findIndex((item) => item.id === selectedAddress.id);
          customerAddresses[addressesToUpdateIndex] = { ...selectedAddress, ...data };
          collection.addresses = customerAddresses;
        } else {
          collection.addresses = [...customerAddresses, { ...selectedAddress, ...data }];
        }
      }

      collection.customerId = id;
      collection.id = id;
      collection.state = customerDataById.state;
      collection.name = customerDataById.name.toUpperCase();
      collection.gstNumber = customerDataById?.gstNumber || "";
      collection.telephoneNumber = customerDataById.telephoneNumber;
      collection.emailAddress = customerDataById?.email || "";
      await dispatch(updateLead(collection)).then(() => {
        dispatch(readCustomerById(id));
        resetLocationInput(null);
        toast.success(` Address ${selectedAddress?.id ? "updated" : deleteAddress?.id ? "deleted" : "added"} `, { autoClose: 1000 });
      });
      setSelectedAddress(null);
      setDeleteAddress(null);
      handleCloseEditLocationModal();
    } else {
      toast.warn("Please fill all the required fields(*)");
    }
  };

  //CONTACT

  const generateUniqueUsername = (name, userList, currentUserId) => {
    const baseUsername = name.trim().toLowerCase().replace(/\s+/g, "").slice(0, 10);
    let finalUsername = baseUsername;
    let counter = 1;

    const existingUsernames = userList.filter((user) => user.userId !== currentUserId).map((user) => user.userName.toLowerCase().trim());

    while (existingUsernames.includes(finalUsername)) {
      const suffix = counter.toString();
      finalUsername = baseUsername.slice(0, 10 - suffix.length) + suffix;
      counter++;
    }

    return finalUsername;
  };

  const addEditContactForm = () => (
    <Box component="form" onSubmit={addEditHandleSubmit(submitAddEditContactForm)} noValidate id="addContactForm" sx={{ minWidth: 400 }}>
      <Stack rowGap={1}>
        <TextField
          margin="normal"
          //required
          value={contactName}
          fullWidth
          id="contactName"
          label="Person Name*"
          name="contactName"
          textTransform="capitalize"
          // autoFocus
          {...addEditContactFormRegister("contactName", {
            setValueAs: (value) => value.replace(/\s+/g, " ").trim(),
          })}
          error={Boolean(validationErrors.contactName)}
          helperText={validationErrors.contactName ? validationErrors.contactName : ""}
          onChange={(e) => {
            const name = e.target.value;
            setContactName(name);

            if (!selectedContact?.info?.username) {
              const newUsername = generateUniqueUsername(name, userList, selectedContact?.info?.userId);
              setUserName(newUsername);
            }

            inputChangeHandler(e);
          }}
        />
        <TextField
          margin="normal"
          //required
          fullWidth
          defaultValue={selectedContact?.userMobileNumber || ""}
          id="contactNumber"
          label="Phone Number*"
          name="contactNumber"
          {...addEditContactFormRegister("contactNumber")}
          error={Boolean(validationErrors.contactNumber)}
          helperText={validationErrors.contactNumber ? validationErrors.contactNumber : ""}
          inputProps={{ maxLength: 10 }}
          onKeyDown={(e) => {
            if (!/[0-9]/.test(e.key) && !["Backspace", "ArrowLeft", "ArrowRight", "Delete", "Tab"].includes(e.key)) {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            inputChangeHandler(e);
            const phone = e.target.value;

            // Only autofill password fields if it's a new contact
            if (!selectedContact?.info?.username) {
              const trimmedPhone = phone.replace(/\D/g, "").slice(0, 6);
              setUserPassword(trimmedPhone);
              setUserConfirmPassword(trimmedPhone);
              addEditSetValue("password", trimmedPhone);
              addEditSetValue("confirmPassword", trimmedPhone);
            }
          }}
        />
        <TextField
          margin="normal"
          //required
          fullWidth
          defaultValue={selectedContact?.email || ""}
          id="contactEmail"
          label="Email*"
          name="contactEmail"
          {...addEditContactFormRegister("contactEmail")}
          error={Boolean(validationErrors.contactEmail)}
          helperText={validationErrors.contactEmail ? validationErrors.contactEmail : ""}
          onChange={inputChangeHandler}
        />
        <TextField
          margin="normal"
          //required
          fullWidth
          defaultValue={selectedContact?.info?.designation || ""}
          id="designation"
          label="Designation"
          name="designation"
          {...addEditContactFormRegister("designation", {
            setValueAs: (value) => value.replace(/\s+/g, " ").trim(),
          })}
          onChange={inputChangeHandler}
        />
        <>
          {selectedContact?.info?.username ? (
            // Editing an existing user
            <>
              <Stack flexDirection={"row"} alignItems={"center"}>
                <Checkbox
                  {...addEditContactFormRegister("resetPassword")}
                  checked={resetPassword}
                  onChange={(event) => {
                    setResetPassword(event.target.checked);
                  }}
                  inputProps={{ "aria-label": "controlled" }}
                />
                <Typography>Set Password</Typography>
              </Stack>

              {resetPassword && (
                <>
                  {/* Username field
                  <TextField
                    margin="normal"
                    required
                    id="userName"
                    name="userName"
                    label="Username"
                    defaultValue={selectedContact?.info?.username || ""}
                    onChange={inputChangeHandler}
                    fullWidth
                    placeholder="Enter your username"
                    error={Boolean(validationErrors.userName)}
                    helperText={validationErrors.userName ? validationErrors.userName : ""}
                    {...addEditContactFormRegister("userName")}
                    InputProps={{
                      readOnly: true, // Make it read-only when resetting
                    }}
                  /> */}

                  {/* Password fields */}
                  <TextField
                    margin="normal"
                    //required
                    id="password"
                    name="password"
                    label="Password*"
                    onChange={inputChangeHandler}
                    fullWidth
                    // placeholder="Password"
                    type={showPassword ? "text" : "password"}
                    error={Boolean(validationErrors.password)}
                    autoComplete="new-password"
                    helperText={validationErrors.password ? validationErrors.password : ""}
                    {...addEditContactFormRegister("password")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowPassword(!showPassword)}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            style={{ position: "absolute", top: 10, right: 10 }}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />

                  <TextField
                    margin="dense"
                    id="confirmPassword"
                    name="confirmPassword"
                    label="Confirm Password*"
                    onChange={inputChangeHandler}
                    fullWidth
                    // placeholder="Confirm Password"
                    type={showConfirmPassword ? "text" : "password"}
                    error={Boolean(validationErrors.confirmPassword)}
                    helperText={validationErrors.confirmPassword ? validationErrors.confirmPassword : ""}
                    {...addEditContactFormRegister("confirmPassword")}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                            style={{ position: "absolute", top: 10, right: 10 }}
                          >
                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </>
              )}
            </>
          ) : (
            <>
              {/* New user */}
              <TextField
                margin="normal"
                // required
                id="userName"
                name="userName"
                label="Username*"
                value={userName || ""}
                onChange={(e) => {
                  setUserName(e.target.value);
                  inputChangeHandler(e);
                }}
                fullWidth
                placeholder={!userName ? "Enter your username" : ""}
                error={Boolean(validationErrors.userName)}
                helperText={validationErrors.userName ? validationErrors.userName : ""}
                {...addEditContactFormRegister("userName")}
              />

              <TextField
                margin="normal"
                // required
                id="password"
                name="password"
                label="Password*"
                onChange={inputChangeHandler}
                fullWidth
                value={userPassword || ""}
                placeholder={userPassword ? "" : "Password"}
                type={showPassword ? "text" : "password"}
                error={Boolean(validationErrors.password)}
                autoComplete="new-password"
                helperText={validationErrors.password ? validationErrors.password : ""}
                {...addEditContactFormRegister("password")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        style={{ position: "absolute", top: 10, right: 10 }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                margin="dense"
                id="confirmPassword"
                name="confirmPassword"
                label="Confirm Password*"
                onChange={inputChangeHandler}
                fullWidth
                value={userConfirmPassword || ""}
                placeholder={userConfirmPassword ? "" : "Password"}
                type={showConfirmPassword ? "text" : "password"}
                error={Boolean(validationErrors.confirmPassword)}
                helperText={validationErrors.confirmPassword ? validationErrors.confirmPassword : ""}
                {...addEditContactFormRegister("confirmPassword")}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                        style={{ position: "absolute", top: 10, right: 10 }}
                      >
                        {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </>
          )}
        </>

        <Stack flexDirection={"row"} alignItems={"center"}>
          <>
            <Checkbox
              {...addEditContactFormRegister("emailServiceReport")}
              checked={emailServiceReport}
              onChange={(event) => {
                setEmailServiceReport(event.target.checked);
              }}
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography>Email Service Report</Typography>
          </>
        </Stack>

        <Stack flexDirection={"row"} justifyContent={"center"} gap={2}>
          <Button
            fullWidth
            variant="contained"
            sx={{ height: 40, mr: 4 }}
            onClick={() => {
              handleCloseEditContactModal();
            }}
          >
            Close
          </Button>
          <Button type="submit" fullWidth variant="contained" sx={{ height: 40 }} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </Button>
        </Stack>
      </Stack>
    </Box>
  );

  const submitAddEditContactForm = async (data) => {
    setIsSubmitting(true);
    try {
      const isNewContact = !selectedContact;
      const isResettingPassword = selectedContact?.info?.username && resetPassword;

      if (isNewContact && !data.userName) {
        data.userName = userName;
      }
      if (!isNewContact) {
        data.userName = selectedContact?.userName;
      }
      if (!isNewContact && !data.contactName) {
        data.contactName = selectedContact?.name;
      }

      if (!data.contactName || !data.contactNumber || !data.contactEmail || (isNewContact && !data.userName)) {
        toast.warn("Please fill all the required fields.");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(data.contactEmail)) {
        toast.warn("Please enter a valid email address.");
        return;
      }

      if ((isNewContact || isResettingPassword) && (!data.password || data.password.length < 6)) {
        toast.warn("Please enter a valid password of at least 6 characters.");
        return;
      }

      if ((isNewContact || isResettingPassword) && data.password !== data.confirmPassword) {
        toast.warn("Passwords do not match.");
        return;
      }

      // if (data.userName) {
      const ifUserNameExists = userList.find(
        (user) =>
          user.userId != selectedContact?.info?.userId &&
          data?.userName &&
          user?.userName.toLowerCase().trim() === data?.userName.toLowerCase().trim()
      );

      if (isNewContact && ifUserNameExists) {
        toast.warn("Username already exists.");
        return;
      }

      const dispatchAction = selectedContact ? updateContact : addContactToLead;

      let payload = {
        id: selectedContact ? selectedContact.id : id,
        mobileNumber: data.contactNumber || null,
        email: data.contactEmail || null,
        name: data.contactName,
        username: data.userName,
        department: asyncStorageValues.departments?.[0]?.id || null,
        info: JSON.stringify({
          designation: data.designation || "",
          emailServiceReport: emailServiceReport ? "Yes" : "No",
          username: data.userName,
        }),
      };

      if (isNewContact || isResettingPassword) {
        payload.password = data.password;
      }
      await dispatch(dispatchAction(payload)).then(() => {
        reset(null);
        dispatch(getAppUsers());
        const actionVerb = selectedContact ? "Updated" : "Added";
        toast.success(`Contact ${actionVerb}`, { autoClose: 1000 });
        dispatch(readCustomerById(id));
      });
      handleCloseEditContactModal();
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleEdit = (machine) => {
    if (machine?.info && machine?.info?.address) {
      setMachineLocations(machine?.info?.address?.locations || []);
    }
    setSelectedModel(machineModels.find((item) => item.id === machine.modelId));
    setSelectedMachine(machine);
    setAddEditMachineModal(true);
  };
  const generateQRCodeImage = async (data) => {
    const qrCodeApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(data)}`;
    const response = await fetch(qrCodeApiUrl);
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  };
  const handleQRCodeClick = async (params) => {
    try {
      const machineData = machinesByCustomerId?.data.find((item) => item.id === params.id);
      if (machineData) {
        const data = `
                Model: ${machineData.model}
                Serial number: ${machineData.serialNumber}
                Maintenance Code: ${machineData?.maintenanceCode || ""}
                Location: ${machineData?.info?.location || ""}
                Address: ${machineData?.info?.address?.address || ""}
                Manufacturer: ${machineData?.manufacturer || ""}
                Manufacturing Year: ${machineData.manufacturingYear}
                AMC: ${machineData.amcExpiryDate ? moment(machineData.amcExpiryDate).format("DD MMM YYYY") : ""}
                Warranty: ${machineData.warrantyExpiryDate ? moment(machineData.warrantyExpiryDate).format("DD MMM YYYY") : ""}
                CustomerId: ${id}
                customerName: ${customerDataById?.name || ""}
                state: ${customerDataById?.state || ""}
                machineId: ${machineData.id}
            `;

        const qrCodeApiUrl = `https://api.qrserver.com/v1/create-qr-code/?size=400x400&data=${encodeURIComponent(data)}`;

        const response = await fetch(qrCodeApiUrl);
        if (!response.ok) {
          console.error("Failed to generate QR code.");
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const downloadLink = document.createElement("a");
        downloadLink.href = blobUrl;
        const custName = customerDataById?.name || "";
        downloadLink.download = `${custName}_${machineData?.maintenanceCode || ""}_qr_code_machine_.png`;

        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);

        URL.revokeObjectURL(blobUrl);
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const generatePDFByAddress = async () => {
    const doc = new jsPDF();
    doc.setFontSize(11);
    const machineList = selectedMachineItems.length
      ? machinesByCustomerId.data.filter((item) => selectedMachineItems.includes(item.id))
      : machinesByCustomerId.data;
    // Group and sort machines by address name
    const machinesByAddress = machineList.reduce((acc, machine) => {
      const addressName = machine?.info?.address?.name || "Unknown Address";
      if (!acc[addressName]) {
        acc[addressName] = [];
      }
      acc[addressName].push(machine);
      return acc;
    }, {});

    // Sort the address keys alphabetically
    const sortedAddressNames = Object.keys(machinesByAddress).sort();

    const qrCodeWidth = 46.2;
    const qrCodeHeight = 46.2;
    const qrCodesPerRow = 3;
    const rowsPerPage = 4;
    const marginLeft = 13;
    const marginTop = 15;
    const spacingX = 67;
    const spacingY = 65;
    const addressHeadingOffset = 7;
    const spacingBetweenAddresses = 2;
    const minRowsBeforePageBreak = 2; // Ensure at least this many rows after the heading

    setHideProgress(false);
    let totalQRCodeCount = machineList.length;
    let currentQRCodeCount = 0;
    let currentPage = 1;
    let qrsOnCurrentPageForAddress = 0;
    let currentYPosition = marginTop;

    for (const addressName of sortedAddressNames) {
      const machinesForAddress = machinesByAddress[addressName];
      qrsOnCurrentPageForAddress = 0; // Reset counter for each new address
      const headingAndFirstRowSpace = addressHeadingOffset + spacingY + spacingBetweenAddresses;

      // Check if there's enough space for the heading and at least the first row
      if (currentYPosition > marginTop && currentYPosition + headingAndFirstRowSpace > doc.internal.pageSize.getHeight()) {
        doc.addPage();
        currentPage++;
        currentYPosition = marginTop;
      }

      // Add address heading
      if (currentYPosition > marginTop) {
        currentYPosition += spacingBetweenAddresses;
      }
      doc.setFontSize(14);
      doc.text(`Address: ${addressName.toUpperCase()}`, marginLeft, currentYPosition - 1.5);
      const addressHeadingY = currentYPosition;
      currentYPosition += addressHeadingOffset;
      doc.setFontSize(11);

      let remainingPageSpace = doc.internal.pageSize.getHeight() - currentYPosition;
      let additionalRowsThatFit = Math.floor((remainingPageSpace - spacingBetweenAddresses) / spacingY);

      for (let i = 0; i < machinesForAddress.length; i++) {
        const row = Math.floor(qrsOnCurrentPageForAddress / qrCodesPerRow);
        const col = qrsOnCurrentPageForAddress % qrCodesPerRow;
        const x = marginLeft + col * spacingX;
        let y = currentYPosition + row * spacingY;

        // Check if adding the QR code will exceed the page height
        if (y + qrCodeHeight + 15 > doc.internal.pageSize.getHeight()) {
          doc.addPage();
          currentPage++;
          currentYPosition = marginTop + addressHeadingOffset;
          y = currentYPosition + Math.floor(0 / qrCodesPerRow) * spacingY;
          qrsOnCurrentPageForAddress = 0;
          y = currentYPosition + Math.floor(qrsOnCurrentPageForAddress / qrCodesPerRow) * spacingY;
        }

        const machine = machinesForAddress[i];
        const formattedData = `
           Maintenance Code: ${machine?.maintenanceCode || ""}
           Address: ${machine?.info?.address?.address || ""}
           Location: ${machine?.info?.location || ""}
           Manufacturer: ${machine?.manufacturer || ""}
           Model: ${machine.model}
           Serial number: ${machine.serialNumber}
           Manufacturing Year: ${machine.manufacturingYear}
           AMC: ${machine.amcExpiryDate}
           Warranty: ${machine.warrantyExpiryDate}
           CustomerId: ${id}
           customerName: ${customerDataById?.name || ""}
           state: ${customerDataById?.state || ""}
           machineId: ${machine.id}
          `;

        const qrCodeImageUrl = await generateQRCodeImage(formattedData);
        doc.text(`QR Code for Service Ticket\n`, x, y - 1.5);
        doc.setFontSize(9);
        doc.text(`${machine.maintenanceCode.toUpperCase()}`, x, y + qrCodeHeight + 5);
        doc.text(`${addressName.toUpperCase()}`, x, y + qrCodeHeight + 10);
        doc.addImage(qrCodeImageUrl, "PNG", x, y, qrCodeWidth, qrCodeHeight);
        doc.setFontSize(11);

        currentQRCodeCount++;
        qrsOnCurrentPageForAddress++;
        const progress = (currentQRCodeCount / totalQRCodeCount) * 100;
        setDownloadProgress(progress);
      }
      // Update the y position for the next address group
      currentYPosition += Math.ceil(machinesForAddress.length / qrCodesPerRow) * spacingY + spacingBetweenAddresses;
    }

    const custName = customerDataById?.name || "";
    doc.save(`${custName}_qr_codes_by_address_${moment().format("DD-MM-YYYY_HH:mm")}.pdf`);

    setDownloadProgress(100);
    setHideProgress(true);
  };

  const deleteContactForm = async (data) => {
    await dispatch(deleteContactById(data));
    dispatch(readCustomerById(id));
    toast.success(`Contact is deleted`, { autoClose: 1000 });
  };

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <Tooltip title="Download QR">
          <Button onClick={() => handleQRCodeClick(params?.row)}>
            <QRCodeIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Edit">
          <Button sx={{ cursor: "pointer", color: "#5D8AA8" }} onClick={() => handleEdit(params.row)}>
            <EditIcon />
          </Button>
        </Tooltip>
      </strong>
    );
  };

  const renderContactsActions = (params) => {
    return (
      <strong>
        <Tooltip title="Edit">
          <Button
            sx={{ cursor: "pointer", color: "#5D8AA8" }}
            onClick={() => {
              const contact = params.row;
              const parsedInfo = typeof contact.info === "string" ? JSON.parse(contact.info) : contact.info;
              setResetPassword(false);
              setAllowTicketCreation(parsedInfo?.canCreateTickets || false);
              setEmailServiceReport(parsedInfo?.emailServiceReport === "Yes");
              setSelectedContact({ ...contact, info: parsedInfo });
              setEditContactModal(true);
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        {/* <Tooltip title="Delete">
          <Button
            onClick={() => {
              setSelectedContact(null);
              setDeleteCustomerContact(params.row);
              setDeleteModal(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip> */}
      </strong>
    );
  };
  const renderLocationsButton = (params) => {
    return (
      <strong>
        <Tooltip title="Edit">
          <Button
            sx={{ cursor: "pointer", color: "#5D8AA8" }}
            onClick={() => {
              setSelectedAddress({
                ...params.row,
                locations: params?.row?.locations?.length ? params.row.locations : ["Default"],
              });
              setAddEditLocationModal(true);
            }}
          >
            <EditIcon />
          </Button>
        </Tooltip>
        <Tooltip title="Delete">
          <Button
            onClick={() => {
              setSelectedContact(null);
              setDeleteAddress(params.row);
              setDeleteModal(true);
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </strong>
    );
  };
  const renderLocations = (params) => {
    const locationsInAddress = params?.row?.location ? params?.row?.location : "";
    return (
      <strong>
        <Tooltip title={locationsInAddress}>
          <div>
            <Typography fontSize={14}>
              {locationsInAddress.length > 40 ? locationsInAddress.slice(0, 40) + "..." : locationsInAddress}
            </Typography>
          </div>
        </Tooltip>
      </strong>
    );
  };

  const dateComparator = (v1, v2) => moment(v1).diff(moment(v2));

  const columns = [
    {
      field: "address",
      headerName: "Address",
      width: 190,
      flex: 0.4,
      // valueGetter: ({ row }) => {
      //   return row?.info?.address?.name || "-";
      // },
    },
    { field: "manufacturer", headerName: "Manufacturer", width: 350, flex: 0.4 },
    { field: "model", headerName: "Model", width: 190, flex: 0.4 },
    {
      field: "serialNumber",
      headerName: "Serial Number",
      width: 160,
      flex: 0.4,
      sortable: true,
      sortComparator: (v1, v2) => {
        return v1.localeCompare(v2, undefined, { numeric: true });
      },
    },
    ...(asyncStorageValues?.acIndustry === true
      ? [
          {
            field: "tonnage",
            headerName: "Tonnage",
            width: 120,
            flex: 0.3,
            valueGetter: ({ row }) => row?.tonnage || "-",
          },
        ]
      : []),
    {
      field: "notes",
      headerName: "Notes",
      width: 190,
      flex: 0.4,
      valueGetter: ({ row }) => {
        return row?.info?.notes || "";
      },
    },
    {
      field: "maintenanceCode",
      headerName: "Machine Code",
      width: 160,
      flex: 0.5,
      sortable: true,
      sortComparator: (v1, v2) => {
        return v1.localeCompare(v2, undefined, { numeric: true });
      },
    },
    {
      field: "location",
      headerName: "Location",
      width: 190,
      flex: 0.4,
      valueGetter: ({ row }) => {
        return row?.info?.location?.location || row?.info?.location || "-";
      },
    },
    {
      field: "amcExpiryDate",
      headerName: "AMC",
      width: 150,
      flex: 0.5,
      sortable: true,
      sortComparator: dateComparator,
    },
    {
      field: "warrantyExpiryDate",
      headerName: "Warranty",
      width: 150,
      flex: 0.5,
      sortable: true,
      sortComparator: dateComparator,
    },
    {
      field: "col6",
      headerName: "",
      width: 150,
      renderCell: renderDetailsButton,
      disableClickEventBubbling: false,
      sortable: false,
      filterable: false,
    },
  ];

  const customerAddressColumns = [
    { field: "name", headerName: "Name", width: 350, flex: 0.4 },
    { field: "address", headerName: "Address", width: 350, flex: 0.4 },
    { field: "type", headerName: "Type", width: 350, flex: 0.4 },
    { field: "location", headerName: "Locations", renderCell: renderLocations, width: 350, flex: 0.4 },
    {
      field: "col6",
      headerName: "",
      width: 150,
      renderCell: renderLocationsButton,
      disableClickEventBubbling: false,
      sortable: false,
      filterable: false,
    },
  ];
  const contactsColumns = [
    { field: "name", headerName: "Name", width: 190, flex: 0.4 },
    {
      field: "userMobileNumber",
      headerName: "Mobile Number",
      width: 160,
      flex: 0.5,
      sortable: true,
      sortComparator: (v1, v2) => {
        return v1.localeCompare(v2, undefined, { numeric: true });
      },
    },
    { field: "email", headerName: "Email", width: 190, flex: 0.4 },
    { field: "userName", headerName: "Username", width: 190, flex: 0.4 },
    {
      field: "col6",
      headerName: "",
      width: 150,
      renderCell: renderContactsActions,
      disableClickEventBubbling: false,
      sortable: false,
      filterable: false,
    },
  ];
  const customeStyle = {
    flex: 1,
    padding: 2,
    mb: 1,
    border: "1px solid #ddd",
    borderRadius: "2px",
    backgroundColor: "#fff",
    boxShadow: "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)",
  };
  const handleSearchChange = (event) => {
    const searchValue = event.target.value;
    setSelectedMachineItems(
      machinesByCustomerId.data
        .filter((item) => `${Object.values(item).join(" ")} ${item.info?.notes || ""}`.toLowerCase().includes(searchValue.toLowerCase()))
        .map((filteredItem) => filteredItem.id)
    );
    setSearchTerm(searchValue);
  };
  const handleClearSearch = () => {
    setSearchTerm("");
    setSearchContactTerm("");
    setSelectedMachineItems([]);
  };
  const handleCloseEditContactModal = () => {
    setValidationErrors({});
    setSelectedContact(null);
    setContactName(null);
    setUserName(null);
    setUserPassword(null);
    setUserConfirmPassword(null);
    setEditContactModal(false);
    setAllowTicketCreation(null);
  };
  const handleCloseEditMachineModal = () => {
    setMachineLocations([]);
    setSelectedModel(null);
    setSelectedMachine(null);
    setSelectedManufacturer(null);
    setAddEditMachineModal(false);
  };
  const handleCloseEditLocationModal = () => {
    setSelectedAddress(null);
    setAddEditLocationModal(false);
  };

  const filteredContacts = customerUsers?.length
    ? customerUsers
        .filter((user) => Object.values(user).join(" ").toLowerCase().includes(searchContactTerm.toLowerCase()))
        .map((user) => ({ ...user, id: user.userId }))
    : [];

  const filteredMachines = machinesByCustomerId.data.filter((item) =>
    `${Object.values(item).join(" ")} ${item.info?.notes || ""} ${item.info?.location?.location || item.info?.location || ""}`
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const filteredAddresses = customerAddresses.filter((item) =>
    Object.values(item).join(" ").toLowerCase().includes(searchLocationTerm.toLowerCase())
  );

  return (
    <div>
      <Stack sx={{ mb: 1 }}>
        <Card sx={{ p: 3, boxShadow: "none" }}>
          {editCustomer ? (
            <>{editCustomerForm()}</>
          ) : (
            <Stack>
              <Stack sx={[customeStyle]}>
                <Stack flexDirection="row" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6" fontWeight={600}>
                    {customerDataById?.name || ""}
                  </Typography>
                  <Button sx={{ height: "self" }} variant="contained" onClick={() => setEditCustomer(true)}>
                    {editCustomer ? "Save" : "Edit"}
                  </Button>
                </Stack>
                <Typography sx={{ display: "inline", textTransform: "capitalize" }} variant="body2">
                  <span style={{ fontWeight: "bold" }}>State:</span> {customerDataById?.state || ""}
                </Typography>

                <Typography sx={{ display: "inline", textTransform: "capitalize" }} variant="body2">
                  <span style={{ fontWeight: "bold" }}>Phone Number:</span> {customerDataById?.telephoneNumber || ""}
                </Typography>

                <Typography sx={{ display: "inline" }} variant="body2">
                  <span style={{ fontWeight: "bold" }}>Email:</span> {customerDataById?.emailAddress || ""}
                </Typography>

                <Typography sx={{ display: "inline", textTransform: "capitalize" }} variant="body2">
                  <span style={{ fontWeight: "bold" }}>Gst Number:</span> {customerDataById?.gstNumber || ""}
                </Typography>
              </Stack>
            </Stack>
          )}
        </Card>
      </Stack>
      {/* <Stack m={5}>{JSON.stringify(machinesByCustomerId.data)}</Stack> */}

      <div>
        <Paper sx={{ mx: 3 }}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
              <Typography fontWeight={"bold"}>Contacts ({filteredContacts.length}) </Typography>
            </AccordionSummary>
            <AccordionActions sx={{ justifyContent: "space-between", direction: "row", mx: 1 }}>
              <OutlinedInput
                id="outlined-adornment-password"
                value={searchContactTerm}
                onChange={(event) => setSearchContactTerm(event.target.value)}
                placeholder="Search..."
                endAdornment={
                  <InputAdornment position="end">
                    {searchContactTerm ? (
                      <IconButton edge="end" onClick={handleClearSearch} size="small">
                        <CloseIcon />
                      </IconButton>
                    ) : (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    )}
                  </InputAdornment>
                }
                sx={{ minWidth: 350, maxWidth: 600, height: 35, marginLeft: "2px" }}
              />
              <div>
                <Button variant="contained" onClick={() => setEditContactModal(true)}>
                  ADD
                </Button>
              </div>
            </AccordionActions>
            <AccordionDetails>
              <Box sx={{ paddingTop: 1 }}>
                <DataGrid
                  autoHeight
                  // checkboxSelection={true}
                  rows={filteredContacts}
                  columns={contactsColumns}
                  pageSize={5}
                  localeText={{ noRowsLabel: "No Data." }}
                  style={{ boxShadow: "0px 3px 15px rgba(0,0,0,0.2)" }}
                  onSelectRow={selectedContact}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Paper>
        <Paper sx={{ mx: 3, my: 1 }}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel2-content" id="panel2-header">
              <Typography fontWeight={"bold"}>Machines ({filteredMachines.length})</Typography>
            </AccordionSummary>
            <AccordionActions sx={{ justifyContent: "space-between", direction: "row", mx: 1 }}>
              <OutlinedInput
                id="outlined-adornment-password"
                value={searchTerm}
                onChange={(event) => handleSearchChange(event)}
                placeholder="Search..."
                endAdornment={
                  <InputAdornment position="end">
                    {searchTerm ? (
                      <IconButton edge="end" onClick={handleClearSearch} size="small">
                        <CloseIcon />
                      </IconButton>
                    ) : (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    )}
                  </InputAdornment>
                }
                sx={{ minWidth: 350, maxWidth: 600, height: 35, marginLeft: "2px" }}
              />
              <div>
                <Stack direction={"row"}>
                  <Stack>
                    <Button
                      startIcon={<DownloadIcon />}
                      sx={{ height: "self" }}
                      autoCapitalize="none"
                      variant="contained"
                      onClick={generatePDFByAddress}
                      disabled={!hideProgress}
                    >
                      Download QR
                    </Button>
                    {downloadProgress !== null && !hideProgress && (
                      <Box sx={{ mt: 0.5 }}>
                        <LinearProgress variant="determinate" value={downloadProgress} />
                        <Typography variant="body2" color="textSecondary">{`${downloadProgress.toFixed(2)}%`}</Typography>
                      </Box>
                    )}
                  </Stack>
                  <Stack>
                    <Button
                      variant="contained"
                      sx={{ ml: 3 }}
                      onClick={() => {
                        generateMaintenanceCode(); // Now, safely generate the code
                        setAddEditMachineModal(true);
                      }}
                    >
                      ADD
                    </Button>
                  </Stack>
                </Stack>
              </div>
            </AccordionActions>
            <AccordionDetails>
              <Box sx={{ paddingTop: 1 }}>
                <DataGrid
                  autoHeight
                  checkboxSelection={true}
                  rows={filteredMachines}
                  columns={columns}
                  pageSize={5}
                  localeText={{ noRowsLabel: "No Data." }}
                  style={{ boxShadow: "0px 3px 15px rgba(0,0,0,0.2)" }}
                  onSelectRow={selectedMachineItems}
                  onRowSelectionModelChange={(newRowSelectionModel) => {
                    setSelectedMachineItems(newRowSelectionModel);
                  }}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Paper>
        <Paper sx={{ mx: 3, mb: 5 }}>
          <Accordion>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel3-content" id="panel3-header">
              <Typography fontWeight={"bold"}>Addresses / Locations ({filteredAddresses.length})</Typography>
            </AccordionSummary>
            <AccordionActions sx={{ justifyContent: "space-between", direction: "row", mx: 1 }}>
              <OutlinedInput
                id="outlined-adornment-password"
                value={searchLocationTerm}
                onChange={(event) => setSearchLocationTerm(event.target.value)}
                placeholder="Search..."
                endAdornment={
                  <InputAdornment position="end">
                    {searchLocationTerm ? (
                      <IconButton edge="end" onClick={handleClearSearch} size="small">
                        <CloseIcon />
                      </IconButton>
                    ) : (
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    )}
                  </InputAdornment>
                }
                sx={{ minWidth: 350, maxWidth: 600, height: 35, marginLeft: "2px" }}
              />
              <div>
                <Stack direction={"row"}>
                  <Button
                    variant="contained"
                    sx={{ ml: 3 }}
                    onClick={() => {
                      setSelectedAddress({ locations: ["Default"] });
                      setAddEditLocationModal(true);
                    }}
                  >
                    ADD
                  </Button>
                </Stack>
              </div>
            </AccordionActions>
            <AccordionDetails>
              <Box sx={{ paddingTop: 1 }}>
                <DataGrid
                  autoHeight
                  // checkboxSelection={true}
                  rows={filteredAddresses}
                  columns={customerAddressColumns}
                  pageSize={5}
                  localeText={{ noRowsLabel: "No Data." }}
                  style={{ boxShadow: "0px 3px 15px rgba(0,0,0,0.2)" }}
                  onSelectRow={selectedMachine}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
        </Paper>
      </div>
      <div>
        <Dialog open={addEditLocationModal} alignSelf="center" onClose={handleCloseEditLocationModal}>
          <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
            {`${selectedAddress && selectedAddress?.id ? "Edit" : "Add"} Address`}
            <IconButton onClick={() => handleCloseEditLocationModal()} style={{ position: "absolute", top: 13, right: 0 }}>
              <CloseIcon />
              <Typography sx={{ mr: 2 }}>Close</Typography>
            </IconButton>
          </DialogTitle>
          <Box sx={{ px: 4, mb: 4 }}>{addEditLocationForm()}</Box>
        </Dialog>
      </div>
      <div>
        <Dialog open={editMachineModal} alignSelf="center" onClose={handleCloseEditMachineModal}>
          <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
            {`${selectedMachine ? "Edit" : "Add"} Machine`}
            <IconButton onClick={() => handleCloseEditMachineModal()} style={{ position: "absolute", top: 13, right: 0 }}>
              <CloseIcon />
              <Typography sx={{ mr: 2 }}>Close</Typography>
            </IconButton>
          </DialogTitle>
          <Box sx={{ px: 4, mb: 4 }}>{addEditMachineForm()}</Box>
        </Dialog>
      </div>
      <div>
        <Dialog open={editContactModal} alignSelf="center" onClose={handleCloseEditContactModal}>
          <DialogTitle id="form-dialog-title" style={{ textAlign: "center" }}>
            {`${selectedContact ? "Edit" : "Add"} Contact`}
            <IconButton
              onClick={() => {
                handleCloseEditContactModal();
              }}
              style={{ position: "absolute", top: 13, right: 0 }}
            >
              <CloseIcon />
              <Typography sx={{ mr: 2 }}>Close</Typography>
            </IconButton>
          </DialogTitle>
          <Box sx={{ px: 4, mb: 4 }}>{addEditContactForm()}</Box>
        </Dialog>
      </div>
      <div>
        <Dialog open={deleteModal} alignSelf="center">
          <Alert
            open={deleteModal}
            // onClose={handleCloseDelete}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <div id="alert-dialog-title">Confirm Action</div>
            <div id="alert-dialog-description">
              Do you want to delete{" "}
              {deleteMachineModel
                ? `this machine (${deleteMachineModel.model})`
                : deleteCustomerContact
                ? `this contact (${deleteCustomerContact.name})`
                : deleteAddress
                ? `this address (${deleteAddress?.address || ""})`
                : null}
              ?
            </div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Button onClick={() => setDeleteModal(false)}>No</Button>
              <Button onClick={() => deleteFunction()}>Yes</Button>
            </div>
          </Alert>
        </Dialog>
      </div>
    </div>
  );
};

export default CustomerContact;
